/**
 * Cell-renderer components for the Subjects EntityTable.
 *
 * Extracted from subjectsEntityConfig.tsx so that file's only exports are
 * config objects/functions (react-refresh/only-export-components — Fast
 * Refresh needs a file to export either only components or only
 * non-components, not a mix).
 */

import React from 'react';
import type { SubjectResponse } from '@features/catalog/api/subjects';

export const SubjectNameCell: React.FC<{ subject: SubjectResponse }> = ({ subject }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <span
      style={{
        display: 'inline-block', width: 10, height: 10, borderRadius: '50%',
        background: subject.color, flexShrink: 0,
      }}
    />
    <span style={{ fontWeight: 500 }}>{subject.name}</span>
  </div>
);
